import script from "./DocsTree.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsTree.vue?vue&type=script&setup=true&lang=js"

import "./DocsTree.vue?vue&type=style&index=0&id=0f69183f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f69183f"]])

export default __exports__